import { call, put, takeLatest } from "redux-saga/effects";
import { specialPrizesPresetsAPI } from "../api/api";
import { SpecialPrizesPresetsActionTypes } from "../actions/actionTypes";
import { API } from "../../../api/api";

function* getPresets(action) {
    try {
        const presets = yield call(() =>
            specialPrizesPresetsAPI.getPresets({
                page: action.payload.page,
                top: action.payload.top,
                search: action.payload.search,
                subsidiaries: action.payload.subsidiaries,
                types: action.payload.types,
                status: action.payload.status,
                certified:action.payload.certified
            })
        );

        yield put({
            type: SpecialPrizesPresetsActionTypes.GET_PRESETS_SUCCESS,
            payload: presets.data
        });
    } catch (e) {
        API.handleError(e.response, "Error fetching Presets");

        yield put({
            type: SpecialPrizesPresetsActionTypes.GET_PRESETS_FAIL,
            payload: e
        });
    }
}

export function* getPresetsWatcher() {
    yield takeLatest(SpecialPrizesPresetsActionTypes.GET_PRESETS, getPresets);
}

function* getPreset(action) {
    try {
        const preset = yield call(() =>
            specialPrizesPresetsAPI.getPreset(action.payload.presetID)
        );

        yield put({
            type: SpecialPrizesPresetsActionTypes.GET_PRESET_SUCCESS,
            payload: preset.data
        });
    } catch (e) {
        API.handleError(e.response, "Error fetching Preset");

        yield put({
            type: SpecialPrizesPresetsActionTypes.GET_PRESET_FAIL,
            payload: e
        });
    }
}

export function* getPresetWatcher() {
    yield takeLatest(SpecialPrizesPresetsActionTypes.GET_PRESET, getPreset);
}